import { call, put, takeLatest } from "redux-saga/effects";

import { ToastError, ToastSuccess } from "../../Global/Toasts/Toasty";
import { makePayload, generateDefaultActions, requestSaga, handleCallback } from "../../../shared-utility/store/utils/helpers";
import { uploadFile } from "../../../shared-utility/store/utils/fileHelper";

export const APPS_SETTINGS_GET_APPS = generateDefaultActions("APPS_SETTINGS_GET_APPS");
export const getApps = () => makePayload(APPS_SETTINGS_GET_APPS.value);
function* getAppsSaga() {
  yield requestSaga(APPS_SETTINGS_GET_APPS, "/appsSettings");
}

export const APPS_SETTINGS_ACTIVATE_APP = generateDefaultActions("APPS_SETTINGS_ACTIVATE_APP");
export const activateApp = appId => ({ type: APPS_SETTINGS_ACTIVATE_APP.value, appId });
function* activateAppSaga(payload) {
  yield requestSaga(APPS_SETTINGS_ACTIVATE_APP, `/appsSettings/${payload.appId}/activate`, "post");
}

export const APPS_SETTINGS_DEACTIVATE_APP = generateDefaultActions("APPS_SETTINGS_DEACTIVATE_APP");
export const deactivateApp = appId => ({ type: APPS_SETTINGS_DEACTIVATE_APP.value, appId });
function* deactivateAppSaga(payload) {
  yield requestSaga(APPS_SETTINGS_DEACTIVATE_APP, `/appsSettings/${payload.appId}/deactivate`, "post");
}

export const APPS_SETTINGS_SAVE_APPS = generateDefaultActions("APPS_SETTINGS_SAVE_APPS");
export const saveApps = apps => ({ type: APPS_SETTINGS_SAVE_APPS.value, apps });
function* saveAppsSaga(payload) {
  yield requestSaga(APPS_SETTINGS_SAVE_APPS, "/appsSettings", "put", payload.apps);
}

export const APPS_SETTINGS_SET_APP_LOGO = generateDefaultActions("APPS_SETTINGS_SET_APP_LOGO");
export const setAppLogo = payload => makePayload(APPS_SETTINGS_SET_APP_LOGO.value, payload);
function* setAppLogoSaga({ appId, file }) {
  try {
    const payload = {
      file,
      url: `/appsSettings/${appId}/logo`
    };
    yield call(uploadFile, payload);
    yield put(APPS_SETTINGS_SET_APP_LOGO.createSuccess());

    return { error: false };
  } catch (error) {
    yield put(APPS_SETTINGS_SET_APP_LOGO.createFailure(error));

    return { error: true };
  }
}

export const APPS_SETTINGS_GET_CAN_EDIT = generateDefaultActions("APPS_SETTINGS_GET_CAN_EDIT");
export const getCanEdit = () => makePayload(APPS_SETTINGS_GET_CAN_EDIT.value);
function* getCanEditSaga() {
  yield requestSaga(APPS_SETTINGS_GET_CAN_EDIT, "/appsSettings/canEdit");
}

export const APPS_SETTINGS_GET_SYSTEM_ADMINS = generateDefaultActions("APPS_SETTINGS_GET_SYSTEM_ADMINS");
export const getSystemAdmins = () => makePayload(APPS_SETTINGS_GET_SYSTEM_ADMINS.value);
function* getSystemAdminsSaga() {
  yield requestSaga(APPS_SETTINGS_GET_SYSTEM_ADMINS, "/systemAdmins");
}

export const APPS_SETTINGS_GET_APPS_ADMINS = generateDefaultActions("APPS_SETTINGS_GET_APPS_ADMINS");
export const getAppsAdmins = payload => makePayload(APPS_SETTINGS_GET_APPS_ADMINS.value, payload);
function* getAppsAdminsSaga(payload) {
  const callback = handleCallback(payload);
  yield requestSaga(APPS_SETTINGS_GET_APPS_ADMINS, "/appsSettings/admins");
  yield callback();
}

export const APPS_SETTINGS_SAVE_APPS_ADMINS = generateDefaultActions("APPS_SETTINGS_SAVE_APPS_ADMINS");
export const saveAppsAdmins = apps => ({ type: APPS_SETTINGS_SAVE_APPS_ADMINS.value, apps });
function* saveAppsAdminsSaga(payload) {
  yield requestSaga(APPS_SETTINGS_SAVE_APPS_ADMINS, "/appsSettings/admins", "put", payload.apps);
}

const initialState = {};

export function appsSettingsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case APPS_SETTINGS_GET_APPS.success:
      return { ...state, apps: payload.data };
    case APPS_SETTINGS_GET_APPS.failure:
      ToastError("Failed to get apps");

      return { ...state, apps: undefined };
    case APPS_SETTINGS_ACTIVATE_APP.success:
      ToastSuccess("Activated app");

      return { ...state, apps: payload.data };
    case APPS_SETTINGS_ACTIVATE_APP.failure:
      ToastError("Failed to activate app");

      return { ...state };
    case APPS_SETTINGS_DEACTIVATE_APP.success:
      ToastSuccess("Dectivated app");

      return { ...state, apps: payload.data };
    case APPS_SETTINGS_DEACTIVATE_APP.failure:
      ToastError("Failed to deactivate app");

      return { ...state };
    case APPS_SETTINGS_SAVE_APPS.success:
      ToastSuccess("Saved apps");

      return { ...state, apps: payload.data };
    case APPS_SETTINGS_SAVE_APPS.failure:
      ToastError("Failed to save apps");

      return { ...state };
    case APPS_SETTINGS_GET_CAN_EDIT.success:
      return { ...state, canEdit: payload.data };
    case APPS_SETTINGS_GET_CAN_EDIT.failure:
      ToastError("Failed to get permission to edit");

      return { ...state, canEdit: undefined };
    case APPS_SETTINGS_GET_SYSTEM_ADMINS.success:
      return { ...state, systemAdmins: payload.data };
    case APPS_SETTINGS_GET_SYSTEM_ADMINS.failure:
      ToastError("Failed to get system admins");

      return { ...state, systemAdmins: undefined };
    case APPS_SETTINGS_GET_APPS_ADMINS.success:
      return { ...state, appsAdmins: payload.data };
    case APPS_SETTINGS_GET_APPS_ADMINS.failure:
      ToastError("Failed to get apps admins");

      return { ...state, appsAdmins: undefined };
    case APPS_SETTINGS_SAVE_APPS_ADMINS.success:
      ToastSuccess("Saved apps admins");

      return { ...state, appsAdmins: payload.data };
    case APPS_SETTINGS_SAVE_APPS_ADMINS.failure:
      ToastError("Failed to save apps admins");

      return { ...state };
    default:
      return state;
  }
}

export function* appsSettingsSaga() {
  yield takeLatest(APPS_SETTINGS_GET_APPS.value, getAppsSaga);
  yield takeLatest(APPS_SETTINGS_ACTIVATE_APP.value, activateAppSaga);
  yield takeLatest(APPS_SETTINGS_DEACTIVATE_APP.value, deactivateAppSaga);
  yield takeLatest(APPS_SETTINGS_SAVE_APPS.value, saveAppsSaga);
  yield takeLatest(APPS_SETTINGS_SET_APP_LOGO.value, setAppLogoSaga);
  yield takeLatest(APPS_SETTINGS_GET_CAN_EDIT.value, getCanEditSaga);
  yield takeLatest(APPS_SETTINGS_GET_SYSTEM_ADMINS.value, getSystemAdminsSaga);
  yield takeLatest(APPS_SETTINGS_GET_APPS_ADMINS.value, getAppsAdminsSaga);
  yield takeLatest(APPS_SETTINGS_SAVE_APPS_ADMINS.value, saveAppsAdminsSaga);
}
